window.FG_TEALIUM_NEWSLETTER_SUB_EMAIL_KEY = window.FG_TEALIUM_NEWSLETTER_SUB_EMAIL_KEY || 'tealium_newsletter_sub_email';

function normalizeTealiumNewsletterEmail(value) {
    return (value || '').toString().trim().toLowerCase();
}

function persistTealiumNewsletterEmail(value) {
    const normalizedEmail = normalizeTealiumNewsletterEmail(value);
    if (!normalizedEmail) return;

    try {
        sessionStorage.setItem(window.FG_TEALIUM_NEWSLETTER_SUB_EMAIL_KEY, JSON.stringify({ email: normalizedEmail }));
    } catch (error) {
        console.warn('Unable to persist newsletter email for Tealium', error);
    }
}

class NewsletterFormPage extends AjaxForm {
    constructor() {
        super();
        this.firstName = this.querySelector('[name="contact[first_name]"]');
        this.lastName = this.querySelector('[name="contact[last_name]"]');
        this.email = this.querySelector('[name="contact[email]"]');
        this.checkbox = this.querySelector('[name="customer[marketing]"]');
        this.gender = this.querySelector('#MyAccount-gender');
        this.birthday = this.querySelector('#MyAccount-dob');
        this.errorMessage = this.querySelector(".form__message.custom_error");
        this.promo = this.querySelector(".form__message.custom_success");
        this.submit = this.querySelector("#Subscribe");
        this.formContainer = this.querySelector('.newsletter-form-container');
    }

    connectedCallback() {
        if (this.submit) {
            this.submit.addEventListener("click", (e) => this.onSubmit(e));
        }

        if (this.formSubmitted()) {
            persistTealiumNewsletterEmail(this.email?.value);
            this.markTealiumPending();
            this.hideForm();
        }
    }

    hideForm() {
        if (this.form) {
            this.formContainer.style.display = 'none';
        }
    }
    
    formSubmitted() {
        const params = new URLSearchParams(window.location.search);
        return params.get("customer_posted") === "true";
    }

    showPromo() {
        this.promo.style.display = "flex";
    }

    markTealiumPending() {
        try {
            sessionStorage.setItem('tealium_newsletter_sub_pending', '1');
            sessionStorage.removeItem('tealium_newsletter_sub_consumed');
        } catch (error) {
            console.warn('Unable to set newsletter subscription flag', error);
        }
    }

    hideMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "none";
        }
    }

    showMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "flex";
        }
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    onSubmit(e) {
        e.preventDefault(); // Prevent default form submission
        this.hideMailError();
        let isValid = true;
        this.querySelectorAll('.error-message').forEach(el => el.textContent = '');
        this.querySelectorAll('.fieldinput').forEach(el => el.classList.remove('tw-error-border'));

        if (!this.firstName.value.trim()) {
            isValid = false;
            this.showMailError();
            this.querySelector('#first-name-error').textContent = 'Please enter your first name.';
            this.firstName.closest('.fieldinput').classList.add('tw-error-border');
        }

        if (!this.lastName.value.trim()) {
            isValid = false;
            this.showMailError();
            this.querySelector('#last-name-error').textContent = 'Please enter your last name.';
            this.lastName.closest('.fieldinput').classList.add('tw-error-border');
        }
        
        // if (!this.checkbox.checked) {
        //     isValid = false;
        //     this.showMailError();
        //     this.querySelector('#accept-marketing-error').textContent = 'Please accept the marketing policy';
        //     this.querySelector('.fieldinput > div > label[for="accept-marketing"]').classList.remove('tw-border-timberwolf');
        //     this.querySelector('.fieldinput > div > label[for="accept-marketing"]').classList.add('tw-border-[#BB251A]');
        // }
        
        if (!this.email.value.trim()) {
            console.log("no mail")
            isValid = false;
            this.showMailError();
            this.querySelector('#email-error').textContent = 'Please enter a valid email address.';
            this.email.closest('.fieldinput').classList.add('tw-error-border');
        } 
        else if (!this.isValidEmail(this.email.value.trim())) {
            isValid = false;
            this.showMailError();
            this.querySelector('#email-error').textContent = 'Please enter a valid email address.';
            this.email.closest('.fieldinput').classList.add('tw-error-border');
        }

        if (isValid) {
            persistTealiumNewsletterEmail(this.email.value);
            this.markTealiumPending();
            this.querySelector('form').submit();
        }
    }
}

customElements.define("newsletter-form-page", NewsletterFormPage);
